import link from "@/scripts/host.js";

export default {
  name: "ConfirmAccount",
  data() {
    return {
      isConfirmed: false
    };
  },
  methods: {
    navigateToMain() {
      this.$router.push('/');
    }
  },
  mounted() {
    this.axios({
      method: "post",
      url: `${link.hostLink}Account/ConfirmEmail`,
      data: { userName: this.$route.params.name, code:this.$route.query.token}
    }).then(() => {
      this.isConfirmed = true;
    })
  }
};
